import { useState } from "react";

import {
  FaBuilding,
  FaFileInvoiceDollar,
  FaShoppingCart,
  FaBoxes,
  FaPercentage,
  FaMoneyCheckAlt,
  FaHashtag,
  FaShieldAlt,
  FaCog,
  FaBalanceScale,
} from "react-icons/fa";

import "./CompanySettings.css";

import CompanyGeneralSettings from "./pages/settings/CompanyGeneralSettings";
import CompanyInvoiceSettings from "./pages/settings/CompanyInvoiceSettings";
import CompanySalesSettings from "./pages/settings/CompanySalesSettings";
import CompanyInventorySettings from "./pages/settings/CompanyInventorySettings";
import CompanyTaxSettings from "./pages/settings/CompanyTaxSettings";
import CompanyPaymentSettings from "./pages/settings/CompanyPaymentSettings";
import CompanyNumberingSettings from "./pages/settings/CompanyNumberingSettings";
import CompanyPreferenceSettings from "./pages/settings/CompanyPreferenceSettings";
import CompanyAccountingSettings from "./CompanyAccountingSettings";

import { usePermissions } from "./PermissionContext";


export default function CompanySettings() {
  const [activeSection, setActiveSection] =
    useState("empresa");

  const { can } = usePermissions();

  const canManageSettings = can("settings.manage");

  const menus = [
    {
      id: "empresa",
      title: "Empresa",
      description:
        "Información general de la empresa",
      icon: <FaBuilding />,
    },
    {
      id: "facturacion",
      title: "Facturación",
      description:
        "Resoluciones y documentos",
      icon: <FaFileInvoiceDollar />,
    },
    {
      id: "ventas",
      title: "Ventas",
      description: "Parámetros de ventas",
      icon: <FaShoppingCart />,
    },
    {
      id: "inventario",
      title: "Inventario",
      description: "Control del stock",
      icon: <FaBoxes />,
    },
    {
      id: "impuestos",
      title: "Impuestos",
      description: "IVA y demás impuestos",
      icon: <FaPercentage />,
    },
    {
      id: "pagos",
      title: "Pagos",
      description: "Métodos y bancos",
      icon: <FaMoneyCheckAlt />,
    },
    {
      id: "numeracion",
      title: "Numeración",
      description:
        "Consecutivos del sistema",
      icon: <FaHashtag />,
    },
    {
      id: "contabilidad",
      title: "Contabilidad",
      description:
        "Cuentas y asientos automáticos",
      icon: <FaBalanceScale />,
    },
    {
      id: "seguridad",
      title: "Seguridad",
      description:
        "Usuarios y permisos",
      icon: <FaShieldAlt />,
    },
    {
      id: "preferencias",
      title: "Preferencias",
      description:
        "Idioma y apariencia",
      icon: <FaCog />,
    },
  ];

  const renderSection = () => {
    switch (activeSection) {
      case "empresa":
        return (
          <CompanyGeneralSettings
            readOnly={!canManageSettings}
          />
        );

      case "facturacion":
        return (
          <CompanyInvoiceSettings
            readOnly={!canManageSettings}
          />
        );

      case "ventas":
        return (
          <CompanySalesSettings
            readOnly={!canManageSettings}
          />
        );

      case "inventario":
        return (
          <CompanyInventorySettings
            readOnly={!canManageSettings}
          />
        );

      case "impuestos":
        return (
          <CompanyTaxSettings
            readOnly={!canManageSettings}
          />
        );

      case "pagos":
        return (
          <CompanyPaymentSettings
            readOnly={!canManageSettings}
          />
        );

      case "numeracion":
        return (
          <CompanyNumberingSettings
            readOnly={!canManageSettings}
          />
        );

      case "contabilidad":
        return (
          <CompanyAccountingSettings
            readOnly={!canManageSettings}
          />
        );

      case "seguridad":
        return (
          <div className="settings-empty">
            <h3>Seguridad</h3>
            <p>
              Los usuarios y permisos se administran
              desde el módulo Usuarios.
            </p>
          </div>
        );

      case "preferencias":
        return (
          <CompanyPreferenceSettings
            readOnly={!canManageSettings}
          />
        );

      default:
        return (
          <CompanyGeneralSettings
            readOnly={!canManageSettings}
          />
        );
    }
  };

  return (
    <div className="company-settings">
      <div className="settings-header">
        <div>
          <p className="settings-kicker">
            CONFIGURACIÓN
          </p>

          <h1>Configuración del Sistema</h1>

          <span>
            Administra todos los parámetros de
            funcionamiento de la empresa.
          </span>

          {!canManageSettings && (
            <p className="settings-readonly-message">
              Estás en modo consulta. No tienes permiso
              para modificar la configuración.
            </p>
          )}
        </div>
      </div>

      <div className="settings-menu-grid">
        {menus.map((menu) => (
          <button
            key={menu.id}
            type="button"
            className={`settings-card ${
              activeSection === menu.id
                ? "active"
                : ""
            }`}
            onClick={() =>
              setActiveSection(menu.id)
            }
          >
            <div className="settings-card-icon">
              {menu.icon}
            </div>

            <div className="settings-card-body">
              <h3>{menu.title}</h3>

              <p>{menu.description}</p>
            </div>
          </button>
        ))}
      </div>

      <div className="settings-content-card">
        {renderSection()}
      </div>
    </div>
  );
}